import { Currency } from '@/core/currency/interfaces';

const XAF: Currency = {
    name: 'Central African CFA Franc BEAC',
    demonym: 'Central African CFA',
    majorSingle: 'Franc',
    majorPlural: 'Francs',
    codeNumeric: '950',
    symbol: 'Fr',
    symbolNative: 'Fr.',
    minorSingle: 'Centime',
    minorPlural: 'Centimes',
    ISOdigits: 0,
    decimals: 0,
    numToBasic: 100,
    code: 'XAF',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default XAF;
